import { selectIsMultiNodeZBPFlow } from "common/user/UserSelectors";
import { createSelector } from "reselect";
import { getInboundDispersalMethod } from "inbounds/steps/InboundStepSelectors";
import { ShippingPlanDispersalMethod } from "@deliverr/inbound-client";
import { selectIsDomesticOrigin } from "inbounds/createShipment/store/selectors/selectIsDomesticOrigin";

export const getShowDestinationFacility = createSelector(
  selectIsMultiNodeZBPFlow,
  selectIsDomesticOrigin,
  getInboundDispersalMethod,
  (isMultiNodeZBPFlow, isDomesticOrigin, dispersalMethod) =>
    isMultiNodeZBPFlow && isDomesticOrigin && dispersalMethod === ShippingPlanDispersalMethod.DIRECT
);
